import { render, staticRenderFns } from "./TooltipIcon.vue?vue&type=template&id=219e7ae9&scoped=true&"
import script from "./TooltipIcon.vue?vue&type=script&lang=js&"
export * from "./TooltipIcon.vue?vue&type=script&lang=js&"
import style0 from "./TooltipIcon.vue?vue&type=style&index=0&id=219e7ae9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219e7ae9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
